const BlockChainOrderStatus = Object.assign({
  OPEN: { title: 'Open', status: 'OPEN', color: 'secondary' },
  PENDING: { title: 'Pending', status: 'PENDING', color: 'orange' },
  QUEUED: { title: 'Queued', status: 'QUEUED', color: 'orange' },
  DELIVERED: { title: 'Delivered', status: 'DELIVERED', color: 'success' },
  ERROR: { title: 'Error', status: 'ERROR', color: 'error' },
});

Object.freeze(BlockChainOrderStatus);

export default BlockChainOrderStatus;



// WEBPACK FOOTER //
// ./src/enum/blockchainOrders/BlockchainOrderStatus.js